import { HttpParameterCodec } from '@angular/common/http';

/**
 * HttpParameterCodec that fully percent-encodes parameter keys and values
 * using `encodeURIComponent`.
 *
 * Angular's default `HttpUrlEncodingCodec` leaves several reserved characters
 * unencoded (notably `+`, which servers interpret as a space in query strings).
 * This codec ensures that characters such as `+`, `&`, `=`, `#`, etc. survive
 * the round-trip to the backend untouched.
 */
export class FullEncodingHttpParamCodec implements HttpParameterCodec {
  encodeKey(key: string): string {
    return encodeURIComponent(key);
  }

  encodeValue(value: string): string {
    return encodeURIComponent(value);
  }

  decodeKey(key: string): string {
    return decodeURIComponent(key);
  }

  decodeValue(value: string): string {
    return decodeURIComponent(value);
  }
}

/** Shared singleton instance to avoid per-request allocations. */
export const FULL_ENCODING_HTTP_PARAM_CODEC = new FullEncodingHttpParamCodec();
